import script from "./TopRightAccount.vue?vue&type=script&setup=true&lang=js"
export * from "./TopRightAccount.vue?vue&type=script&setup=true&lang=js"

import "./TopRightAccount.vue?vue&type=style&index=0&id=4d796552&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d796552"]])

export default __exports__